export default __webpack_public_path__ + "static/media/logout.3c230508.svg";